<template>
  <tk-container
    class="h-full"
  >
    <div
      slot="header"
      class="flex items-center w-full px-15 pt-15 mb-10"
    >
      <global-back />
      <global-title class="flex-grow ml-10" />
    </div>
    <div class="h-5" />
    <div class="w-full px-15 pb-15 pt-10">
      <div
        class="flex-center flex-col rounded-14 bg-white px-20 py-40 shadow"
      >
        <!-- 标题 -->
        <div class="flex-center flex-col">
          <div class="text-18 font-bold">
            请输入兑换码
          </div>
          <div class="mt-4 h-4 w-19 rounded-10 bg-red" />
        </div>
        <!-- 输入框 -->
        <van-cell-group
          :border="false"
          class="py-16 !mx-0 !m-t-50 !bg-transparent w-full"
        >
          <van-field
            v-model="code"
            :label-width="0"
            placeholder="例：H7xWBrYt"
            class="border-width-1 p-0"
            input-align="center"
          />
        </van-cell-group>
        <div
          class="h-1 w-full bg-gray-F1F4F8"
        />
        <!-- 兑换按钮 -->
        <div
          class="mt-50 w-full overflow-hidden rounded-16"
        >
          <van-button
            class="w-full"
            color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
            :disabled="!code.length"
            :loading="btnLoading"
            @click="exchange"
          >
            立即兑换
          </van-button>
        </div>
        <!-- 兑换记录 -->
        <div
          class="mt-16 flex cursor-pointer items-center text-14 text-gray spacex-6"
          @click="$push({
            path: '/common/record',
            query: {
              type: 'code',
            },
          })"
        >
          <div>兑换记录</div>
          <van-icon class="mt-1" name="arrow" />
        </div>
      </div>
      <!-- 弹框提示 -->
      <van-dialog
        v-model="show"
        :show-confirm-button="false"
        :class-name="['px-15', 'py-30']"
      >
        <!-- 关闭按钮 -->
        <div
          class="w-full flex cursor-pointer justify-end"
          @click="show = false"
        >
          <van-icon name="cross" color="#9C9C9C" />
        </div>
        <!-- 提示图标 -->
        <div class="tips-bg-color m-auto circle-38 flex-center">
          <van-icon v-if="status === 'fail'" name="cross" color="white" size="22" />
          <van-icon v-else name="success" color="white" size="22" />
        </div>
        <div class="flex-center py-10 text-17 font-bold">
          {{ status === 'fail' ? '兑换失败' : '兑换成功' }}
        </div>
        <div class="flex-center pt-10 text-14 text-gray">
          {{ status === 'fail' ? tipsMsg : '您已成功兑换课程，快去学习吧～' }}
        </div>
        <!-- 确认按钮 -->
        <div
          class="mt-30 w-full rounded-16 overflow-hidden"
        >
          <van-button
            class="w-full"
            color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
            @click="toPage"
          >
            确认
          </van-button>
        </div>
      </van-dialog>
    </div>
  </tk-container>
</template>

<script>
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      code: '',
      course: '',
      show: false,
      status: '',
      tipsMsg: '',
      btnLoading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      sessionToken: state => state.sessionToken,
    })
  },
  methods: {
    async exchange () {
      this.course = ''
      this.btnLoading = true
      if (!this.user || !this.sessionToken) {
        this.btnLoading = false
        return this.$push(
          this.$tkUa.isWechat ? '/auth/login?type=login' : '/auth/scan'
        )
      }
      let { data: res } = await this.$tkParse.post('/exchangeCodes/exchangeCourse', {
        code: this.code,
        user: this.user.objectId,
      }).catch((e) => {
        this.btnLoading = false
        Toast.fail('发送失败，网络错误')
        throw e
      })
      if (!res.status) {
        this.btnLoading = false
        return Toast.fail('发送失败，服务端错误')
      }
      if (res.status === 'fail') {
        this.show = true
        this.status = res.status
        this.tipsMsg = `您输入的兑换码错误，${res.message}～`
        this.btnLoading = false
        return
      }
      this.code = ''
      this.show = true
      this.status = res.status
      this.course = res.data.course
      Toast.success('兑换成功')
      this.btnLoading = false
    },
    async toPage () {
      if (this.status === 'fail') {
        this.show = false
        return
      }
      this.code = ''
      this.show = false
      this.$push({
        path: '/course/courseDetail',
        query: {
          id: this.course,
        },
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .tk-container-content {
    background: transparent !important;
  }
  .scroll-content {
    height: 100%;
    background: linear-gradient(57deg, #F8ECEC 35%, #E8F5FE 98%);
  }
  .tk-container-header {
    background: linear-gradient(90deg, #F8ECEC 10%, #E8F5FE 50%);
  }
}
.tips-bg-color {
  background: linear-gradient(270deg, #FC966E 0%, #F96654 100%), #3D3D3D;
  .van-icon-cross{
    font-weight: bold;
  }
}
</style>
